import { apiClient } from '@/api/client';

export interface CalibrationRecommendation {
  recommendation: {
    id: string;
    materialId: string;
    clinicId: string;
    currentProceduresPerUnit: string;
    suggestedProceduresPerUnit: string;
    confidenceLevel: 'LOW' | 'MEDIUM' | 'HIGH';
    reason: string;
    proceduresAnalyzed: string;
    expectedConsumption: string;
    actualConsumption: string;
    discrepancy: string;
    status: 'PENDING' | 'ACCEPTED' | 'DISMISSED';
    createdAt: string;
    resolvedAt?: string;
    resolvedBy?: string;
  };
  material: {
    id: string;
    name: string;
    unit: string;
    brand: string;
    category: string;
  };
}

export const calibrationApi = {
  async getPendingRecommendations(): Promise<CalibrationRecommendation[]> {
    const response = await apiClient.get(
      `/material-calibration/recommendations`,
    );
    return response.data;
  },

  async analyzeAndGenerate() {
    const response = await apiClient.post(`/material-calibration/analyze`);
    return response.data;
  },

  async acceptRecommendation(id: string) {
    const response = await apiClient.post(`/material-calibration/accept/${id}`);
    return response.data;
  },

  async dismissRecommendation(id: string) {
    const response = await apiClient.post(
      `/material-calibration/dismiss/${id}`,
    );
    return response.data;
  },

  async getHistory(materialId: string) {
    const response = await apiClient.get(
      `/material-calibration/history/${materialId}`,
    );
    return response.data;
  },
};
